import { render, staticRenderFns } from "./Approved.vue?vue&type=template&id=4edcbeb0&scoped=true&"
import script from "./Approved.vue?vue&type=script&lang=js&"
export * from "./Approved.vue?vue&type=script&lang=js&"
import style0 from "./Approved.vue?vue&type=style&index=0&id=4edcbeb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edcbeb0",
  null
  
)

export default component.exports